import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

import {
  defineComponent,
  reactive,
  toRefs,
  computed,
  watch,
} from "vue";
import { stateList as states } from "@/core/listas/stateList";
import axios from "axios";
import { useUsuarioStore } from "@/store/usuarioStore";


export default /*#__PURE__*/_defineComponent({
  __name: 'MunicipioUfPerfilDados',
  props: {
  modelValue: {
    type: [String, Number],
    required: false,
    default: "",
  },
  municipioLabel: {
    type: String,
    default: "Município",
  },
  ufLabel: {
    type: String,
    default: "UF",
  },
  isAvailableShow: {
    type: Boolean,
    default: true,
  },
  municipioClass: {
    type: String,
    default: "col-sm-4",
  },
  ufClass: {
    type: String,
    default: "col-sm-2",
  },
  currentUf: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  requiredMunicipio: {
    type: Boolean,
    default: undefined,
  },
  isFilter: {
    type: Boolean,
    default: false,
  },
  disableMod: {
    type: Boolean,
    default: false,
  },
},
  emits: ["changeUf", "update:modelValue"],
  setup(__props, { emit: __emit }) {

const emit = __emit;
const usuarioStore = useUsuarioStore();

const props = __props;

const data = reactive({
  municipios: [] as any,
  uf: "" as any,
  municipio: "" as any,
});

const { municipios, uf, municipio } = toRefs(data);

const stateList = computed(() => {
  const ufsPermitidas = usuarioStore.perfilDados?.uf;
  if (ufsPermitidas && ufsPermitidas.length > 0) {
    return states.filter((state) => ufsPermitidas.includes(state.value));
  }
  return states;
});

async function onChangeCarregarMunicipios(event) {
  const uf = event?.target?.value || event;
  emit("changeUf", data.uf);
  if (uf) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_ADMIN_API}/municipio/listagem/${uf}`
      );

      let municipiosList = response.data.dados.map((dado) => ({
        value: dado.id,
        label: dado.nome,
      }));

      const perfilMunicipioId = usuarioStore.perfilDados?.municipioId;
      if (perfilMunicipioId) {
        municipiosList = municipiosList.filter(
          (m) => m.value === perfilMunicipioId
        );
        if (municipiosList.length === 1) {
          data.municipio = perfilMunicipioId;
          emit("update:modelValue", data.municipio);
        }
      }

      data.municipios = municipiosList;
    } catch (error) {
      data.municipios = [];
    }
  }
}

function onChange() {
  return emit("update:modelValue", data.municipio);
}

watch(
  () => props.currentUf,
  (value) => {
    if (value === "clearfilter") {
      data.uf = null;
      data.municipios = [];
      return;
    }
    if (value) {
      data.uf = value;
      onChangeCarregarMunicipios(value);
    }
  }
);

watch(
  () => props.modelValue,
  (modelValue) => {
    data.municipio = modelValue;
  }
);

watch(
  () => props.isAvailableShow,
  (value) => {
    if (!value) {
      data.municipio = "";
      data.uf = "";
    }
  }
);

watch(
  () => stateList.value,
  (lista) => {
    if (lista.length === 1 && !data.uf) {
      data.uf = lista[0].value;
      onChangeCarregarMunicipios(data.uf);
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.isAvailableShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(__props.ufClass)
        }, [
          _createVNode(_component_InputSelect, {
            label: `${__props.ufLabel}:`,
            name: "uf",
            modelValue: _unref(uf),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(uf) ? (uf).value = $event : null)),
            onChange: onChangeCarregarMunicipios,
            placeholder: "Selecione uma das opções",
            required: __props.required,
            options: stateList.value,
            disabled: __props.disableMod
          }, null, 8, ["label", "modelValue", "required", "options", "disabled"])
        ], 2))
      : _createCommentVNode("", true),
    (__props.isAvailableShow)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(__props.municipioClass)
        }, [
          _createVNode(_component_InputSelect, {
            label: `${__props.municipioLabel}:`,
            name: "municipio_id",
            modelValue: _unref(municipio),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(municipio) ? (municipio).value = $event : null)),
            disabled: (__props.isFilter && !_unref(municipios).length) || __props.disableMod,
            onChange: onChange,
            placeholder: "Selecione uma das opções",
            required: __props.requiredMunicipio !== undefined ? __props.requiredMunicipio : __props.required,
            options: _unref(municipios)
          }, null, 8, ["label", "modelValue", "disabled", "required", "options"])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})